import classNames from 'classnames';
import { getFileIcon } from './FileToIconMapper';

export function FileIcon(props: { mimeType: string | undefined; additionalCssClass?: string }) {
    return <i className={classNames('fa-lg', props.additionalCssClass, getFileIcon(props.mimeType))} />;
}
